import { Container, Button } from "react-bootstrap";
import { useScroll } from "../../../context/scroll-context";
import { Link } from "react-router-dom";
import aiml from "../../../images/home/ai-img.svg";
import webApp from "../../../images/home/web-app.svg";
import blockchain from "../../../images/home/blockchain-cube.svg";
import ux from "../../../images/home/ux-img.svg";
import softwareTesting from "../../../images/home/software-testing.svg";
import analytics from "../../../images/home/chart.svg";
import rpa from "../../../images/home/rpa.svg";
import mobility from "../../../images/home/mobility.svg";
import devops from "../../../images/home/coding.svg";
import cloud from "../../../images/home/cloud-computing.svg";

const ServicesList = () => {
    const { scrollToSection, contactform } = useScroll();

    const handleScrollAndClose = (refName) => {
        scrollToSection(refName);
    };

    // Routing paths for each service
    const serviceUrlRouting = {
        "AI/ML": "/services/artificial_intelligence",
        "Web Apps Development": "/services/web_app",
        "Blockchain Developer": "/services/blockchain_app",
        "UX/UI Services": "/services/hire_UIUX_developer",
        "Software Testing": "/services/machine_learning",
        "Analytics": "/services/business_intelligence",
        "RPA": "/services/robotic_process_automation",
        "Mobility": "/services/android_app",
        "DevOps": "/services/hire_devops_engineer",
        "Cloud": "/services/cloud_strategy",
    };

    const servicesLeft = [
        { name: "AI/ML", imgSrc: aiml, altText: "AI/ML Icon" },
        { name: "Web Apps Development", imgSrc: webApp, altText: "Web Apps Icon" },
        { name: "Blockchain Developer", imgSrc: blockchain, altText: "Blockchain Icon" },
        { name: "UX/UI Services", imgSrc: ux, altText: "UX/UI Icon" },
        { name: "Software Testing", imgSrc: softwareTesting, altText: "Software Testing Icon" },
    ];

    const servicesRight = [
        { name: "Analytics", imgSrc: analytics, altText: "Analytics Icon" },
        { name: "RPA", imgSrc: rpa, altText: "RPA Icon" },
        { name: "Mobility", imgSrc: mobility, altText: "Mobility Icon" },
        { name: "DevOps", imgSrc: devops, altText: "DevOps Icon" },
        { name: "Cloud", imgSrc: cloud, altText: "Cloud Icon" },
    ];

    return (
        <section className="services-list-section">
            <Container fluid>
                <h2 className="text-center mb-4">How Can We Help You?</h2>
                <div className="d-flex justify-content-center gap-4 gap-lg-5 content-block flex-wrap">
                    <div className="d-flex flex-column flex-grow-1 gap-4">
                        {servicesLeft.map((service, index) => (
                            <div className="d-flex align-items-center" key={index}>
                                <div className="icon-circle me-2">
                                    <img src={service.imgSrc} alt={service.altText} className="img-fluid" />
                                </div>
                                <Link to={serviceUrlRouting[service.name]} className="icon-text">
                                    {service.name}
                                </Link>
                            </div>
                        ))}
                    </div>
                    <div className="d-flex flex-column flex-grow-1 gap-4">
                        {servicesRight.map((service, index) => (
                            <div className="d-flex align-items-center" key={index}>
                                <div className="icon-circle me-2">
                                    <img src={service.imgSrc} alt={service.altText} className="img-fluid" />
                                </div>
                                <Link to={serviceUrlRouting[service.name]} className="icon-text">
                                    {service.name}
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="text-center">
                    <Button variant="primary" className="text-uppercase mt-3 mt-lg-5 d-inline-flex" onClick={() => handleScrollAndClose(contactform)}>
                        Apply for a free 2 weeks trial
                    </Button>
                </div>
            </Container>
        </section>
    );
};

export default ServicesList;
